import axios from 'axios';
import { X_API_KEY } from '../utils/authentication';

const apiVersion = "v1"
// from the root of the site
let apiUrl = `${window.location.origin}/t4t/api/${apiVersion}`;

const lumInfosAction = 'luminfos';

function getApiBaseUrl() {
    return apiUrl;
}

export function getLumInfosApiUrl(projectId, driverId) {
    return `?projectId=${projectId}&driverId=${driverId}`;
}

export function getLumInfosTypeApiUrl(projectId, driverId) {
    return `/selected?projectId=${projectId}&driverId=${driverId}`;
}

export function updateLumInfosTypeApiUrl(projectId, driverId, type) {
    return `/selected?projectId=${projectId}&driverId=${driverId}&type=${type}`;
}

export function getLumInfosPropertiesApiUrl(projectId, driverId) {
    return `/selected/properties?projectId=${projectId}&driverId=${driverId}`;
}

export function updateLumInfosPropertiesApiUrl(projectId, driverId) {
    return `/selected/properties?projectId=${projectId}&driverId=${driverId}`;
}

const instance = axios.create({
    baseURL: `${getApiBaseUrl()}/${lumInfosAction}`,
    timeout: 30000,
    headers: { 'Access-Control-Allow-Origin': '*', 'CLIENT-ID': "Frontend" }
});

instance.interceptors.request.use(config => {
    if (localStorage.getItem(X_API_KEY) !== null && typeof localStorage.getItem(X_API_KEY) === 'string' && localStorage.getItem(X_API_KEY) !== '') {
        config.headers['X-API-KEY'] = localStorage.getItem(X_API_KEY);
    } else {
        delete config.headers['X-API-KEY'];
    }
    return config;
});

export default instance;
